import React, { Component } from 'react';
import PropTypes from 'prop-types';
import YouTube from 'react-youtube';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { EditorState, convertFromRaw } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import { stateFromHTML } from 'draft-js-import-html';
import style from './ActivityView.css';
import Image from '../../components/Image';
import ageIcon from '../../../public/icons/007-age.png';
import curriculumIcon from '../../../public/icons/001-idea.png';
import goalIcon from '../../../public/icons/005-settings.png';
import materialIcon from '../../../public/icons/003-folder.png';
import strategyIcon from '../../../public/icons/004-creativity.png';
import safetyIcon from '../../../public/icons/002-protection-shield-with-a-check-mark.png';
import blankImage from '../../../public/icons/no-image-available.jpg';
import { getYoutubeToken, withModalBody } from '../../utils/util';
import FormComponent from '../../components/FormComponent';
import RichEditor from '../../components/RichEditor';
import { MonthEnum, AgeColors, AgeEnum } from '../../constants';

const getSecondaryAgeOptions = (formState, onChange) => {
  if (formState.age) {
    const ageList = [AgeEnum.IT, AgeEnum.PSC, AgeEnum.OSC];
    const nonSelectedAges = ageList.filter(a => a !== formState.age);
    return (
      <select
        className="form-control mb-1"
        name="secondaryAge"
        value={formState.secondaryAge}
        onChange={onChange}
      >
        <option value='' hidden>
          Secondary Age
        </option>
        <option value={nonSelectedAges[0]}>{nonSelectedAges[0]}</option>
        <option value={nonSelectedAges[1]}>{nonSelectedAges[1]}</option>
        <option value={nonSelectedAges.join(', ')}>{nonSelectedAges.join(', ')}</option>
      </select>
    );
  }
};

const initialEditorState = EditorState.createWithContent(
  convertFromRaw({
    entityMap: {},
    blocks: [
      {
        text: '',
        key: 'foo',
        type: 'unstyled',
        entityRanges: []
      }
    ]
  })
);

const initialFormState = {
  title: '',
  visible: '',
  week: '',
  day: '',
  month: '',
  age: '',
  secondaryAge: '',
  area: '',
  objective: '',
  materials: initialEditorState,
  strategies: initialEditorState,
  safety: initialEditorState,
  textSource: '',
  image: [],
  imageSource: '',
  videoUrl: ''
};

const AddActivityModalBody = ({
  isFetching,
  errorMessage,
  formState,
  onChange,
  onImageChange,
  modalRef,
  onSave,
  edit,
  deleteImage
}) => (
  <form className="modal-body" onSubmit={onSave}>
    <FormComponent
      label
      name="title"
      value={formState.title}
      onChange={onChange}
      placeholder="Title"
      required
      errorMessage={errorMessage && errorMessage.title}
    />
    <div className={style.formComponent}>
      <label style={{ fontWeight: 700 }} htmlFor="visible">
        <span>Visible</span>
      </label>
      <select
        className="form-control"
        name="visible"
        value={formState.visible}
        onChange={onChange}
      >
        <option value="" hidden>
          Visible
        </option>
        <option value="true">Yes</option>
        <option value="false">No</option>
      </select>
    </div>
    <div className={style.formComponent}>
      <label style={{ fontWeight: 700 }} htmlFor="month">
        <span>Month</span>
      </label>
      <select
        className="form-control"
        name="month"
        value={formState.month}
        onChange={onChange}
      >
        <option value="" hidden>
          Month
        </option>
        <option value={MonthEnum.JANUARY}>January</option>
        <option value={MonthEnum.FEBRUARY}>February</option>
        <option value={MonthEnum.MARCH}>March</option>
        <option value={MonthEnum.APRIL}>April</option>
        <option value={MonthEnum.MAY}>May</option>
        <option value={MonthEnum.JUNE}>June</option>
        <option value={MonthEnum.JULY}>July</option>
        <option value={MonthEnum.AUGUST}>August</option>
        <option value={MonthEnum.SEPTEMBER}>September</option>
        <option value={MonthEnum.OCTOBER}>October</option>
        <option value={MonthEnum.NOVEMBER}>November</option>
        <option value={MonthEnum.DECEMBER}>December</option>
      </select>
    </div>
    <div className={style.formComponent}>
      <label style={{ fontWeight: 700 }} htmlFor="week">
        <span>Week</span>
      </label>
      <select
        className="form-control mb-1"
        name="week"
        value={formState.week}
        onChange={onChange}
      >
        <option value="" hidden>
          Week
        </option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
      </select>
    </div>
    <div className={style.formComponent}>
      <label style={{ fontWeight: 700 }} htmlFor="day">
        <span>Day</span>
      </label>
      <select
        className="form-control mb-1"
        name="day"
        value={formState.day}
        onChange={onChange}
      >
        <option value="" hidden>
          Day
        </option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
      </select>
    </div>
    <div className={style.formComponent}>
      <label style={{ fontWeight: 700 }} htmlFor="age">
        <span>Age</span>
      </label>
      <select
        className="form-control mb-1"
        name="age"
        value={formState.age}
        onChange={onChange}
      >
        <option value="" hidden>
          Age
        </option>
        <option value={AgeEnum.IT}>{AgeEnum.IT}</option>
        <option value={AgeEnum.PSC}>{AgeEnum.PSC}</option>
        <option value={AgeEnum.OSC}>{AgeEnum.OSC}</option>
      </select>
      {getSecondaryAgeOptions(formState, onChange)}
    </div>
    <FormComponent
      label
      name="area"
      value={formState.area}
      onChange={onChange}
      placeholder="Area"
      errorMessage={errorMessage && errorMessage.area}
    />
    <FormComponent
      label
      name="objective"
      value={formState.objective}
      onChange={onChange}
      placeholder="Objective"
      errorMessage={errorMessage && errorMessage.objective}
    />
    <div className={style.formComponent}>
      <label style={{ fontWeight: 700 }} htmlFor="materials">
        <span>Materials</span>
      </label>
      <RichEditor
        name="materials"
        editorState={formState.materials}
        placeholder="Materials"
        onChange={editorState =>
          onChange({
            target: { name: 'materials', value: editorState }
          })}
      />
    </div>
    <div className={style.formComponent}>
      <label style={{ fontWeight: 700 }} htmlFor="strategies">
        <span>Strategies</span>
      </label>
      <RichEditor
        name="strategies"
        editorState={formState.strategies}
        placeholder="Strategies"
        onChange={editorState =>
          onChange({
            target: { name: 'strategies', value: editorState }
          })}
      />
    </div>
    <div className={style.formComponent}>
      <label style={{ fontWeight: 700 }} htmlFor="safety">
        <span>Safety</span>
      </label>
      <RichEditor
        name="safety"
        placeholder="Safety"
        editorState={formState.safety}
        onChange={editorState =>
          onChange({
            target: { name: 'safety', value: editorState }
          })}
      />
    </div>
    <FormComponent
      label
      name="textSource"
      type="url"
      value={formState.textSource}
      onChange={onChange}
      placeholder="Text source"
      errorMessage={errorMessage && errorMessage.textSource}
    />
    <Image
      image={formState.image}
      errorMessage={errorMessage.image}
      onImageChange={onImageChange}
      deleteImage={deleteImage}
    />
    <FormComponent
      label
      name="imageSource"
      type="url"
      value={formState.imageSource}
      onChange={onChange}
      placeholder="Image source"
      errorMessage={errorMessage && errorMessage.imageSource}
    />
    <FormComponent
      label
      type="url"
      name="videoUrl"
      value={formState.videoUrl}
      onChange={onChange}
      placeholder="YouTube Url"
      errorMessage={errorMessage && errorMessage.videoUrl}
    />
    <div className="modal-footer">
      <button type="button" className="btn btn-secondary" data-dismiss="modal">
        Close
      </button>
      <button
        type="submit"
        className="btn btn-success"
        data-dismiss={modalRef ? '' : 'modal'}
      >
        {edit ? 'Update' : 'Create'}
      </button>
    </div>
  </form>
);

const AddActivityModal = withModalBody(AddActivityModalBody);

class ActivityView extends Component {
  static contextTypes = { fetch: PropTypes.func.isRequired };

  state = {
    isFetching: false,
    errorMessage: {},
    formState: initialFormState,
    activity: this.props.activity,
    currentImageIndex: 0
  };

  handleAddActivityModalSave = evt => {
    evt.preventDefault();
    const handleAddActivityModalSaveAsync = async () => {
      let errors = null;
      let data = null;
      this.setState({ isLoading: true });
      const formData = new FormData();
      if (this.state.formState.deletedImages) {
        formData.append(
          'deletedImages',
          JSON.stringify(this.state.formState.deletedImages)
        );
      }

      const { file } = this.state.formState;
      if (file) {
        file.map(f => f.file && formData.append('file', f.file, f.file.name));
      }
      if (this.state.formState.imageChanged) {
        formData.append(
          'imageChanged',
          JSON.stringify(this.state.formState.imageChanged)
        );
      }
      if (this.state.activityId) {
        formData.append('id', this.state.activityId);
      }

      formData.append('visible', this.state.formState.visible || 'true');
      const {
        title,
        area,
        objective,
        textSource,
        imageSource,
        videoUrl
      } = this.state.formState;
      formData.append(
        'json_content',
        JSON.stringify({
          title,
          area,
          objective,
          textSource,
          imageSource,
          videoUrl,
          month: this.state.formState.month || MonthEnum.JANUARY,
          week: this.state.formState.week || '1',
          day: this.state.formState.day || '1',
          age: this.state.formState.age || AgeEnum.IT,
          secondaryAge: this.state.formState.secondaryAge || '',
          materials: stateToHTML(
            this.state.formState.materials.getCurrentContent()
          ),
          strategies: stateToHTML(
            this.state.formState.strategies.getCurrentContent()
          ),
          safety: stateToHTML(this.state.formState.safety.getCurrentContent())
        })
      );
      try {
        const resp = await this.context.fetch('/api/activity', {
          body: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        data = await resp.json();
      } catch (exception) {
        errors = exception.message;
      } finally {
        let activity;
        // hide modal programmatically
        if (!errors && window.$) {
          $(this.addActivityModal).modal('hide');
          $('.modal-backdrop').remove();
          activity = {
            ...data.json_content,
            id: data.id
          };
          activity.image = data.photos.map(photo => ({
            id: photo.id,
            photo:
              !photo.json_info.image.startsWith('data') &&
              !photo.json_info.image.startsWith('/uploads')
                ? `/uploads/${photo.json_info.image}`
                : photo.json_info.image
          }));
          // current image was deleted
          if (this.state.currentImageIndex >= activity.image.length) {
            this.setState({
              currentImageIndex: 0
            });
          }
        }

        this.setState({
          isLoading: false,
          errorMessage: errors || {}, // assumption: server return error dictionary [labelname]: [errormessage]
          formState: initialFormState,
          activity
        });
      }
    };
    handleAddActivityModalSaveAsync();
  };

  handleImageChange = (event, idx) => {
    event.preventDefault();
    const file = event.target.files[0];
    if (!file) {
      return;
    }
    // limit < 1mb
    if (file.size > 1000000) {
      this.setState({
        errorMessage: {
          ...this.state.errorMessage,
          image: [
            ...this.state.errorMessage.image.slice(0, idx),
            'Please upload a picture smaller than 1 MB.',
            ...this.state.errorMessage.image.slice(idx + 1)
          ]
        }
      });
    } else {
      const { image, ...rest } = this.state.errorMessage;
      const reader = new FileReader();
      let imageChanged = this.state.formState.imageChanged;
      if (!imageChanged) {
        imageChanged = [];
      }
      imageChanged[idx] = true;

      reader.onload = upload => {
        this.setState({
          errorMessage: rest,
          formState: {
            ...this.state.formState,
            image: [
              ...this.state.formState.image.slice(0, idx),
              {
                photo: upload.target.result
              },
              ...this.state.formState.image.slice(idx + 1)
            ],
            file: (this.state.formState.file && [
              ...this.state.formState.file,
              {
                idx,
                file
              }
            ]) || [
              {
                idx,
                file
              }
            ],
            imageChanged
          }
        });
      };
      reader.readAsDataURL(file);
    }
  };

  handleOnChange = event => {
    this.setState({
      formState: {
        ...this.state.formState,
        [event.target.name]: event.target.value
      }
    });
  };

  handleImageClick = (event, idx) => {
    event.preventDefault();
    this.setState({
      currentImageIndex: idx
    });
  };

  getAgeColor = age => {
    let color;
    switch (age) {
      case AgeEnum.IT:
        color = AgeColors.IT;
        break;
      case AgeEnum.PSC:
        color = AgeColors.PSC;
        break;
      default:
        color = AgeColors.OSC;
    }
    return color;
  };

  deleteImage = idx => {
    if (this.state.formState.image.length < 1) {
      return;
    }

    const image = [
      ...this.state.formState.image.slice(0, idx),
      ...this.state.formState.image.slice(idx + 1)
    ];

    const file =
      this.state.formState.file &&
      this.state.formState.file.filter(file => file.idx !== idx);

    const imageChanged = this.state.formState.imageChanged && [
      ...this.state.formState.imageChanged.slice(0, idx),
      ...this.state.formState.imageChanged.slice(idx + 1)
    ];

    const deletedImages = (this.state.formState.deletedImages && [
      ...this.state.formState.deletedImages.slice(0, idx),
      this.state.formState.image[idx].id,
      ...this.state.formState.deletedImages.slice(idx + 1)
    ]) || [this.state.formState.image[idx].id];

    this.setState({
      formState: {
        ...this.state.formState,
        image,
        file,
        imageChanged,
        deletedImages
      }
    });
  };

  render() {
    const {
      id,
      title,
      week,
      day,
      age,
      secondaryAge,
      area,
      objective,
      materials,
      strategies,
      safety,
      textSource,
      image,
      imageSource,
      videoUrl
    } = this.state.activity;
    return (
      <div className="container">
        <div className="row">
          {this.props.isAdmin && (
            <div>
              <AddActivityModal
                modalName="addActivityModal"
                modalTitle="Edit Activity"
                onSave={this.handleAddActivityModalSave}
                onChange={this.handleOnChange}
                isFetching={this.state.isFetching}
                errorMessage={this.state.errorMessage}
                formState={this.state.formState}
                onImageChange={this.handleImageChange}
                modalRef={el => (this.addActivityModal = el)}
                noFooter
                edit
                deleteImage={this.deleteImage}
              />
              <button
                className="btn btn-primary m-2"
                aria-hidden="true"
                data-toggle="modal"
                data-target="#addActivityModal"
                onClick={() => {
                  // fix issue with `stateFromHTML` not having document error on the server
                  if (typeof window !== 'undefined') {
                    const form = {
                      ...this.state.activity,
                      materials: EditorState.createWithContent(
                        stateFromHTML(materials)
                      ),
                      strategies: EditorState.createWithContent(
                        stateFromHTML(strategies)
                      ),
                      safety: EditorState.createWithContent(
                        stateFromHTML(safety)
                      )
                    };
                    this.setState({
                      activityId: id,
                      formState: form,
                      edit: true
                    });
                  }
                }}
              >
                Edit
              </button>
              <a className="btn btn-primary m-2" href="/activity">
                All activities
              </a>
            </div>
          )}
          <h1 className={style.title}>{title}</h1>
          <div className="col-md-6">
            <div className={style.topic}>
              <img src={ageIcon} alt="icon" />
              <div>
                Age: <span>{age}</span>
                <svg height="20" width="30">
                  <circle
                    cx="17"
                    cy="9"
                    r="8"
                    stroke="black"
                    fill={this.getAgeColor(age)}
                  />
                </svg>
              </div>
            </div>
            { secondaryAge &&
            <div className={style.secondaryAge}>
              Secondary Age: <span>{secondaryAge}</span>
            </div>
            }
            <div className={style.topic}>
              <img src={curriculumIcon} alt="icon" />
              <div>
                Curriculum Area: <span>{area}</span>
              </div>
            </div>
            <div className={style.topic}>
              <img src={goalIcon} alt="icon" />
              <div>
                Developmental Goal/Activity Objective: <span>{objective}</span>
              </div>
            </div>
            <div className={style.topic}>
              <img src={materialIcon} alt="icon" />
              <div>
                Materials Needed:
                <span>
                  {materials !== '<p><br></p>' ? (
                    <div
                      className={style.listedItems}
                      dangerouslySetInnerHTML={{ __html: materials }}
                    />
                  ) : (
                    ' n/a'
                  )}
                </span>
              </div>
            </div>
            <div className={style.topic}>
              <img src={strategyIcon} alt="icon" />
              <div>
                Procedures/Strategies:
                <span>
                  {strategies !== '<p><br></p>' ? (
                    <div
                      className={style.listedItems}
                      dangerouslySetInnerHTML={{ __html: strategies }}
                    />
                  ) : (
                    ' n/a'
                  )}
                </span>
              </div>
            </div>
            <div className={style.topic}>
              <img src={safetyIcon} alt="icon" />
              <div>
                Guidance and Safety Considerations:
                <span>
                  {safety !== '<p><br></p>' ? (
                    <div
                      className={style.listedItems}
                      dangerouslySetInnerHTML={{ __html: safety }}
                    />
                  ) : (
                    ' n/a'
                  )}
                </span>
              </div>
            </div>
            {textSource && (
              <div className={style.topic}>
                <div className={style.source}>
                  Source:
                  <span>
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href={textSource}
                    >
                      {` ${textSource}`}
                    </a>
                  </span>
                </div>
              </div>
            )}
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-12">
                {videoUrl && (
                  <YouTube
                    videoId={getYoutubeToken(videoUrl)}
                    className={style.youtube}
                    opts={{ width: '100%', height: '400px' }}
                  />
                )}
                {image[this.state.currentImageIndex] ? (
                  <img
                    alt="activity pic"
                    src={image[this.state.currentImageIndex].photo}
                    className={`img-thumbnail ${style.currentImage}`}
                  />
                ) : (
                  <img
                    src={blankImage}
                    className={`img-thumbnail ${style.currentImage}`}
                  />
                )}
              </div>
              {image && image.length > 1 ? (
                <div className="col-md-12">
                  {image.map(
                    (src, idx) =>
                      image ? (
                        <img
                          alt="activity pic"
                          key={`image-${idx}`}
                          src={src.photo}
                          className={`img-thumbnail ${style.thumbnailImage}`}
                          onClick={event => this.handleImageClick(event, idx)}
                        />
                      ) : (
                        <img
                          src={blankImage}
                          className={`img-thumbnail ${style.thumbnailImage}`}
                        />
                      )
                  )}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(style)(ActivityView);



// WEBPACK FOOTER //
// ./src/routes/activityView/ActivityView.js